<template>
<div>
   <v-dialog max-width="300px" v-model="deleteConfirmation">
     <v-card>
       <v-card-title>Delete List</v-card-title>
       <v-card-text>Are you sure you want to delete this list?</v-card-text>
       <v-card-actions>
         <v-btn small text @click="deleteListItem(item)">Delete</v-btn>
         <v-spacer></v-spacer>
         <v-btn dark color="green lighten-1" small @click="deleteConfirmation = false">Cancel</v-btn>
        </v-card-actions>
     </v-card>
   </v-dialog>
  <v-card
    color="#385F73"
    dark
  >
    <v-card-title class="title py-0 pl-4"> 
      <v-row justify="space-between">
        {{item ? item.get('name') : ''}}
        <v-btn text color="green lighten-1" class="mt-0" small v-if="listOwner && item && item.get('public')" @click="item.set('public', false); updateList(item)"> Make Private </v-btn>
        <v-btn text color="green lighten-1" class="mt-0" small v-if="listOwner && item && !item.get('public')" @click="item.set('public', true); updateList(item)"> Make Public </v-btn>
      </v-row>
    </v-card-title>
    <v-card-subtitle class="pt-3 pb-0">{{item ? item.get('notes') : ''}}</v-card-subtitle>
    <v-card-actions class="">
      <v-btn color="green lighten-1" class="mt-0" small :to="'/list/' + item.id">Open</v-btn>
      <v-btn color="green lighten-1" class="mt-0" small :href="sendSMS(item)">Share</v-btn>
      
      <v-spacer></v-spacer>
      <span class="grey--text text--lighten-3 font-weight-light pr-6">Created by: {{item && item.get('createdBy') ? item.get('createdBy').get('name'): ''}}</span>
      <v-icon v-if="listOwner" small @click="deleteConfirmation = true">delete</v-icon>
    </v-card-actions>
  </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  props: ['item'],
  data: () => ({
    deleteConfirmation: false,
  }),
  methods: {
    ...mapActions(['deleteListItem', 'updateList']),
    sendSMS(item_) {
      var name = this.user.get('name') || ''
      var sms = 'Click here to view my Ubtane List!' + "%0A" + "%0A"
      sms += "Name: " + item_.get('name') + "%0A"
      sms += "Description: " + item_.get('notes') + "%0A"
      sms += "https://www.ubtane.com/list/" + item_.id
      return "sms:&body=" + sms
    },
  },
  computed: {
    ...mapState(['user',]),
    listOwner() {
      var x = this.item ? this.item.get('createdBy') : null;
      if (this.user && x && x.id === this.user.id) return true
      return false
    },
  },
  watch: {
  }
};
</script>
